import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import './DarkModeToggle.css';

const DarkModeToggle = () => {
  const { darkMode, toggleDarkMode } = useTheme();

  return (
    <button 
      className={`dark-mode-toggle ${darkMode ? 'dark' : ''}`}
      onClick={toggleDarkMode}
      title={darkMode ? 'Slå av mørk modus' : 'Slå på mørk modus'}
      aria-label={darkMode ? 'Slå av mørk modus' : 'Slå på mørk modus'}
    >
      <span className="toggle-icon">{darkMode ? '🌙' : '☀️'}</span>
      <span className="toggle-label">{darkMode ? 'Lys' : 'Mørk'}</span>
    </button>
  );
};

export default DarkModeToggle;
